<template>
    <div v-loading="true"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
         element-loading-text="正在準備付款頁面，請稍候…"
    class="h-100">
        <div>
                    <form method="post" ref="payForm" >
                        <input type="hidden" name="MerchantID" ><br>
                        <input type="hidden" name="TradeInfo" ><br>
                        <input type="hidden" name="TradeSha" ><br>
                        <input type="hidden" name="Version" value="2.0"><br>
                    </form>
        </div>
    </div>


</template>

<script>
import FN from "@/components/fn.vue";
import {ADD_SHIPMENT_ORDER, GET_CONTAINER_PAY_INFO} from "@/api";

export default {
    mixins: [FN],
    data() {
        return {
            id: '',
            title: '新增詢價',
            MerchantID: '',
            TradeInfo: '',
            TradeSha: '',
        };
    },
    methods: {
        /**
         *  獲取最新聯絡人資訊
         */
        getPayInfo() {
            this.FETCH({
                key: 'GET_CONTAINER_PAY_INFO',
                id: this.id,
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.checkout());
                } else if (+(res || {}).code === 0) {
                    console.log(res.data);
                    this.dontOpenExternal(true);
                    this.$refs.payForm.MerchantID.value = res.data.MerchantID;
                    this.$refs.payForm.TradeInfo.value = res.data.TradeInfo;
                    this.$refs.payForm.TradeSha.value = res.data.TradeSha;
                    this.$refs.payForm.action = res.data.action;
                    this.$refs.payForm.submit();
                } else {
                    this.$message('連線異常，請稍後重試');
                }
            });
        },
        /**
         * 停用跳出app功能
         * @param status
         */
        dontOpenExternal(status) {
            try {
                window.flutter_inappwebview.callHandler('dontOpenExternal', status).then(function (success) {
                    console.log('停用跳出app功能執行狀態', success);
                })
            } catch (e) {
                console.log('停用跳出app功能-錯誤', e);
            }
        },
    },
    mounted() {
        this.id = this.$route.params.id;
        this.getPayInfo();
    },

};
</script>
